export default {
  invalid: '{fieldName} نامعتبر است',
  confirmed: 'مقدار {fieldName} باید با {target} یکسان باشد',
  required: '{fieldName} الزامی است'
}
